import React from 'react'
import './MobileNav.css'
const MobileNav = ({isOpen,toogleMenu}) => {
  return (
    <div
      className={`mobile-menu ${isOpen?"active":""}`} onClick={toogleMenu}
    >
      <div className='mobile-menu-container'>
        <img className='logo' src='./assets/images/logo.svg' alt=''/>
        <ul>
            <li>
                <a className='menu-item'>Home</a>
            </li>
            <li>
            <a href="#skills-container" className="menu-item">
              Skills
            </a>
            </li>
          <li>
            <a href="#portfolio" className="menu-item">
              Projects
            </a>
            </li>
          <li>
            <a href="#contact" className="menu-item">
              Contact Me
            </a>
            </li>
            
        </ul>
      </div>
    </div>
  )
}

export default MobileNav
